export const enviarNotificacionFCM = async (pedido) => {
  const token = localStorage.getItem("fcm_token_prueba");

  if (!token) {
    console.log("⚠️ No existe token FCM para este dispositivo");
    return;
  }

  try {
    const respuesta = await fetch("https://api.adipanperu.com/notifications/send-notification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token,
        title: "🆕 Nuevo pedido",
        body: `Nuevo pedido del usuario ${pedido.idUsuario || ""}`,
      }),
    });

    const resultado = await respuesta.json();
    if (resultado.ok) {
      console.log("📱 Notificación FCM enviada");
    } else {
      console.error("❌ Error del servidor FCM:", resultado);
    }

    try {
      const respuestaCorreo = await fetch("https://api.adipanperu.com/notifications/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pedido,
        }),
      });

      const resultadoCorreo = await respuestaCorreo.json();

      if (resultadoCorreo.ok) {
        console.log("📧 Correo de nuevo pedido enviado");
      } else {
        console.error("❌ Error enviando correo:", resultadoCorreo);
      }
    } catch (error) {
      console.error("❌ Error conectando con el servidor de correo:", error);
    }

  } catch (error) {
    console.error("❌ Error enviando FCM:", error);
  }
};
